export default __webpack_public_path__ + "static/media/star.6711de0a.svg";